import React from 'react';
import { motion } from 'framer-motion';
interface CoverImageProps {
  src: string;
  alt: string;
  className?: string;
  rotation?: number;
  hoverEffect?: boolean;
}
export function CoverImage({
  src,
  alt,
  className = '',
  rotation = 0,
  hoverEffect = true
}: CoverImageProps) {
  return <motion.div whileHover={hoverEffect ? {
    y: -5,
    scale: 1.02
  } : {}} transition={{
    duration: 0.4,
    ease: 'easeOut'
  }} className={`relative rounded-md overflow-hidden shadow-soft border border-border/40 group ${className}`} style={{
    transform: `rotate(${rotation}deg)`
  }} data-id="element-52">
      <img src={src} alt={alt} className="w-full h-full object-cover" data-id="element-53" />
      {/* Subtle overlay for premium feel */}
      <div className="absolute inset-0 bg-gradient-to-tr from-black/5 to-transparent pointer-events-none mix-blend-overlay" data-id="element-54"></div>
      {/* Gold hairline border on hover */}
      {hoverEffect && <div className="absolute inset-0 border border-accent/0 group-hover:border-accent/50 transition-colors duration-500 rounded-md pointer-events-none" data-id="element-55"></div>}
    </motion.div>;
}